import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 系统消息管理 -- 系统消息列表
  msgList(data, method) {
    return ajax('post', getRequestUrl('/msg/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 系统消息管理 -- 系统消息详情
  msgInfo(data, method) {
    return ajax('post', getRequestUrl('/api/Message/msgInfo'), data, {
      method,
    })
  },

  // 系统消息管理 -- 删除系统消息
  msgDelete(data, method) {
    return ajax('post', getRequestUrl('/msg/delete'), data, {
      method,
    })
  },

  // 系统消息管理 -- 消息反馈列表
  newsFeedbackList(data, method) {
    return ajax('post', getRequestUrl('/api/Message/newsFeedbackList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 系统消息管理 -- 发送信息
  msgPush(data, method) {
    return ajax('post', getRequestUrl('/msg/push'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 系统消息管理 -- 删除消息反馈
  newsFeedbackDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Message/newsFeedbackDelete'), data, {
      method,
    })
  },

  // 系统消息管理 -- 私信列表
  privateMsgList(data, method) {
    return ajax('post', getRequestUrl('/msg/private/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 系统消息管理 -- 私信详情
  privateMsgdetail(data, method) {
    return ajax('post', getRequestUrl('/msg/private/detail'), data, {
      method,
    })
  },

  // 系统消息管理 -- 删除私信
  privateMsgDelete(data, method) {
    return ajax('post', getRequestUrl('/msg/private/delete'), data, {
      method,
    })
  },

  // 系统消息管理 -- 发送私信
  privateMsgSend(data, method) {
    return ajax('post', getRequestUrl('/msg/private/push'), data, {
      method,
    })
  },

  // 系统消息管理 -- 房间公屏列表
  roomScreenList(data, method) {
    return ajax('post', getRequestUrl('/api/Message/roomScreenList'), data, {
      method,
    })
  },

  // 系统消息管理 -- 房间公屏列表
  roomScreenSet(data, method) {
    return ajax('post', getRequestUrl('/api/Message/roomScreenSet'), data, {
      method,
    })
  },

  // 系统消息管理 -- 删除
  roomScreenDelete(data, method) {
    return ajax('post', getRequestUrl('/api/Message/roomScreenDelete'), data, {
      method,
    })
  },

  // 系统消息管理 -- 活动消息列表
  actMsgList(data, method) {
    return ajax('post', getRequestUrl('/msg/activity/list'), data, {
      method,
    })
  },

  // 系统消息管理 -- 验证活动ID
  actMsgCheckId(data, method) {
    return ajax('post', getRequestUrl('/msg/activity/check'), data, {
      method,
    })
  },

  // 系统消息管理 -- 创建/编辑活动消息
  actMsgSave(data, method) {
    return ajax('post', getRequestUrl('/msg/activity/create'), data, {
      method,
    })
  },

  // 系统消息管理 -- 复制消息
  copyActMsg(data, method) {
    return ajax('post', getRequestUrl('/msg/activity/copy'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/message.js